import React, { useState } from "react";
import { Bot, Calculator, Stethoscope } from "lucide-react";
import AIChatbot from "@/components/ai/AIChatbot";
import AIPriceEstimator from "@/components/ai/AIPriceEstimator";
import AIDiagnosis from "@/components/ai/AIDiagnosis";

const tabs = [
  { id: "chat", label: "AI Villanyszerelő", icon: Bot, sub: "Volt Vince — kérdezz bármit" },
  { id: "price", label: "AI Árkalkulátor", icon: Calculator, sub: "Becsült ár pillanatok alatt" },
  { id: "diag", label: "Hibadiagnosztika", icon: Stethoscope, sub: "Tünet → diagnózis" },
];

export default function AIFeatures() {
  const [active, setActive] = useState("chat");

  return (
    <section
      id="ai"
      data-testid="ai-section"
      className="relative border-b border-[#262626] bg-[#0A0A0A] overflow-hidden"
    >
      <div className="voltage-bar absolute top-0 left-0" />

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="font-mono text-xs text-[#FFD700] uppercase tracking-[0.4em] mb-3">
              [ 02 / AI Eszközök ]
            </div>
            <h2 className="font-heading uppercase text-4xl md:text-6xl leading-none mb-6">
              Jövőbe mutató<br />
              <span className="text-[#FFD700]">megoldások.</span>
            </h2>
            <p className="text-[#A3A3A3] mb-8 text-lg leading-relaxed">
              Próbáld ki <span className="text-white font-bold">VOLT VINCE</span>-t &mdash; saját AI villanyszerelőnket,
              aki magyarul válaszol, becsült árat ad, és hibadiagnózist készít a leírásod alapján.
            </p>

            <div className="space-y-2">
              {tabs.map((t) => {
                const Icon = t.icon;
                const isActive = active === t.id;
                return (
                  <button
                    key={t.id}
                    onClick={() => setActive(t.id)}
                    data-testid={`ai-tab-${t.id}`}
                    className={`w-full flex items-center gap-4 p-4 border-2 text-left transition-all ${
                      isActive
                        ? "bg-[#FFD700] text-black border-[#FFD700]"
                        : "bg-black text-white border-[#262626] hover:border-[#FFD700]"
                    }`}
                  >
                    <div
                      className={`w-12 h-12 flex items-center justify-center border-2 ${
                        isActive ? "bg-black text-[#FFD700] border-black" : "bg-[#FFD700] text-black border-[#FFD700]"
                      }`}
                    >
                      <Icon className="w-6 h-6" strokeWidth={2.5} />
                    </div>
                    <div className="flex-1">
                      <div className="font-heading uppercase text-lg leading-none">{t.label}</div>
                      <div className={`font-mono text-xs mt-1 ${isActive ? "text-black/70" : "text-[#A3A3A3]"}`}>
                        {t.sub}
                      </div>
                    </div>
                    <div
                      className={`font-mono text-xs ${isActive ? "text-black" : "text-[#FFD700]"}`}
                    >
                      {isActive ? "■" : "□"}
                    </div>
                  </button>
                );
              })}
            </div>

            <div className="mt-6 p-4 border border-[#262626] bg-black/50 font-mono text-xs text-[#A3A3A3]">
              ⚡ Az AI csak iránymutató. Végleges árajánlatért és hivatalos diagnózisért
              kérje szerelőink kiszállását.
            </div>
          </div>

          <div className="lg:col-span-7" data-testid="ai-panel">
            {active === "chat" && <AIChatbot />}
            {active === "price" && <AIPriceEstimator />}
            {active === "diag" && <AIDiagnosis />}
          </div>
        </div>
      </div>
    </section>
  );
}
